import HttpService from "../HttpService";

export const order = async (data) => {
    const res = await HttpService({
        method: 'POST',
        url: '/api/v2/cart',
        data
    });
    return res.data;
};

export const resendVerification = async () => {

    const res = await HttpService({
        method: 'PUT',
        url: '/api/v2/members/resend'
    });

    return res.data;
};

export const updatePaymentOldCard = async ({ id, data }) => {
    const res = await HttpService({
        method: 'PUT',
        url: '/api/v2/group_orders/' + id + '/update_payment_method',
        data
    });
    return res.data;
};
export const paymentOldCard = async ({ id, data }) => {
    const res = await HttpService({
        method: 'PUT',
        url: '/api/v2/group_orders/' + id + '/complete',
        data
    });
    return res.data;
};

export const cancelGroupOrder = async (id) => {

    const res = await HttpService({
        method: 'DELETE',
        url: '/api/v2/group_orders/' + id
    });

    return res.data;
};

export const fetchGroupOrders = async (slug) => {

    const res = await HttpService({
        method: 'GET',
        url: '/api/v2/group_orders/' + slug,
    });

    return res.data;
};

export const paymentCompleteGroupOrders = async (data) => {

    const res = await HttpService({
        method: 'PUT',
        url: '/api/v2/group_orders/' + data.id + '/complete',
        data: data.data
    });

    return res.data;
}

export const uploadCSV = async ({ id, csv_file }) => {
    const res = await HttpService({
        method: 'POST',
        type: 'multipart/form-data',
        url: '/api/v2/group_orders/' + id + '/invite_members',
        data: { csv_file }
    });

    return res.data;
};

export const setupIntentGroupOrder = async ({ id, group_order }) => {
    const res = await HttpService({
        method: 'PUT',
        url: '/api/v2/group_orders/' + id + '/setup_intent',
        data: {
            group_order
        }
    });

    return res.data;
};
export const updateGroupOrder = async ({ id, group_order }) => {
    const res = await HttpService({
        method: 'PUT',
        url: '/api/v2/group_orders/' + id,
        data: {
            group_order
        }
    });

    return res.data;
};

export const getGroupOrderItems = async (id) => {

    const res = await HttpService({
        method: 'GET',
        url: '/api/v2/group_orders/' + id + '/group_order_items',
    });

    return res.data;
};

export const getMyMember = async () => {

    const res = await HttpService({
        method: 'GET',
        url: '/api/v2/member',
    });

    return res.data;
};

export const saveUserGoDashboardSettings = async (data) => {
    const res = await HttpService({
        method: 'POST',
        url: '/api/v2/group_order_dashboard_settings/user_go_dashboard_settings',
        data
    });
    return res.data;
};

export const showGoDashboardSettings = async (params) => {
    const res = await HttpService({
        method: 'GET',
        url: '/api/v2/group_order_dashboard_settings/show_go_dashboard_setting',
        params
    });
    return res.data;
};

// checkbox
export const toggleMembersLimitSettings = async ({ user_id, enabled }) => {
    const res = await HttpService({
        method: 'PUT',
        url: `/api/v2/users/${user_id}/member_settings/enable_limit_settings`,
        data: {
            user_id: user_id,
            enable_members_limit_setting: enabled,
        },
    });
    return res.data;
};

// show
export const showManageMembersSettings = async ({ user_id, params }) => {
    const res = await HttpService({
        method: 'GET',
        url: `api/v2/users/${user_id}/member_settings`,
        params
    });

    return res.data;
};

// create + update
export const updateManageMembersSettings = async ({ user_id, members }) => {
    const res = await HttpService({
        method: 'PUT',
        url: `/api/v2/users/${user_id}/member_settings`,
        data: {
            member_setting: {
                members,
            },
        },
    });
    return res.data;
};

// delete
export const deleteManageMembersSettings = async ({ user_id, id }) => {
    const res = await HttpService({
        method: 'DELETE',
        url: `/api/v2/users/${user_id}/member_settings/members/${id}`
    });

    return res.data;
};


//  show email notifications
export const showEmailNotificationSetting = async (user_id) => {
    const res = await HttpService({
        method: 'GET',
        url: `/api/v2/users/${user_id}/go_notification_settings`,
    });

    return res.data;
};


// update email notification
export const updateNotificationSettings = async ({ user_id, go_notification_settings }) => {
    const res = await HttpService({
        method: 'PUT',
        url: `/api/v2/users/${user_id}/go_notification_settings_update`,
        data: { go_notification_settings },
    });
    return res.data;
};

// show Delivery Control Panel Settings
export const showDeliveryControlPanelSettings = async ({ user_id, params }) => {
    const res = await HttpService({
        method: 'GET',
        url: `/api/v2/${user_id}/group_orders_by_day`,
        params
    });

    return res.data;
};

// notify food arrived
export const notifyFoodArrived = async ({ order_id, notes }) => {
    const res = await HttpService({
        method: 'POST',
        url: `/api/v2/group_orders/${order_id}/notify_food_arrived`,
        data: { notes }
    });

    return res.data;
};